import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Home from "./components/Home/Home";
import Anfahrt from "./components/Anfahrt/Anfahrt";
import Impressum from "./components/Impressum/Impressum";
import Tattoo from "./components/Tattoo/Tattoo";
import WannaDos from "./components/WannaDos/WannaDos";
import Piercing from "./components/Piercing/Piercing";
import PiercingArbeiten from "./components/Piercing/PiercingArbeiten";
import PiercingPflege from "./components/Piercing/PiercingPflege";
import TerminTattoo from "./components/Termin/TerminTattoo";
import TerminPiercing from "./components/Termin/TerminPiercing";
import AdminHome from "./components/Admin/AdminHome/AdminHome";
import AdminTattoo from "./components/Admin/AdminTattoo/AdminTattoo";
import AdminWannaDo from "./components/Admin/AdminWannaDo/AdminWannaDo";
import AdminPiercing from "./components/Admin/AdminPiercing/AdminPiercing";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import AdminTattooEdit from "./components/Admin/AdminTattoo/AdminTattooEdit";
import AdminWannaDoEdit from "./components/Admin/AdminWannaDo/AdminWannaDoEdit";
import AdminPiercingEdit from "./components/Admin/AdminPiercing/AdminPiercingEdit";
import AdminPflege from "./components/Admin/AdminPflege/AdminPflege";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/tattoo/arbeiten",
        element: <Tattoo />,
      },
      {
        path: "/tattoo/wannados",
        element: <WannaDos />,
      },
      {
        path: "/piercing",
        element: <Navigate to="/piercing/preise" replace />,
      },
      {
        path: "/piercing/preise",
        element: <Piercing />,
      },
      {
        path: "/piercing/arbeiten",
        element: <PiercingArbeiten />,
      },
      {
        path: "/piercing/pflege",
        element: <PiercingPflege />,
      },
      {
        path: "/terminTattoo",
        element: <TerminTattoo />,
      },
      {
        path: "/terminPiercing",
        element: <TerminPiercing />,
      },
      {
        path: "/anfahrt",
        element: <Anfahrt />,
      },
      {
        path: "/impressum",
        element: <Impressum />,
      },
      {
        path: "/admin",
        element: <AdminHome />,
      },
      {
        path: "/admin/tattoo",
        element: <AdminTattoo />,
      },
      {
        path: "/admin/tattoo/edit",
        element: <AdminTattooEdit />,
      },
      {
        path: "/admin/wanna-dos/edit",
        element: <AdminWannaDoEdit />,
      },
      {
        path: "/admin/wanna-dos",
        element: <AdminWannaDo />,
      },
      {
        path: "/admin/piercing",
        element: <AdminPiercing />,
      },
      {
        path: "/admin/piercing/edit",
        element: <AdminPiercingEdit />,
      },
      {
        path: "/admin/pflege",
        element: <AdminPflege />,
      },
    ],
  },
]);
root.render(
  <>
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  </>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
